// **BEGIN** Hextom TMS Integration - DO NOT MODIFY
      var hextom_tms = {
        selectorInsertType:  "insert",
        regionType:  "region_name_currency_symbol",
        availableLocalesById: {},
        availableLocales: [],
        primaryLocaleById: {},
        merchantSelectedLocale: "shop_base",
        hasFlag: "no",
        selectorFlagMap: {'en': 'en', 'tr': 'tr'},
        displayType: "language_name",
        fontColor: "#FFFFFF",
        backgroundColor: "#2C332F",
        backgroundOpacity: "1.0",
        buttonFontColor: "#FFFFFF",
        buttonBackgroundColor: "#000000",
        selectorType: "market_language",
        selectorStyle: "dropdown",
        hasFlagRegion: "yes",
        defaultRegion: "TR",
        primaryRegionById: {},
        availableRegionsByCode: {},
        availableRegions: [],
        primaryDomain: "",
        popupEnable: false,
        popupTextColor: "#000000",
        popupBgColor: "#FFFFFF",
        popupBtnTextColor: "#FFFFFF",
        popupBtnBgColor: "#000000",
        regions: [{"name": "Turkey", "code": "TR", "currency": {"code": "TRY", "symbol": "\u20ba"}, "languages": {"English": {"name": "English", "native_name": "English", "code": "en", "default": true}, "T\u00fcrk\u00e7e": {"name": "T\u00fcrk\u00e7e (Turkish)", "native_name": "T\u00fcrk\u00e7e", "code": "tr", "default": false}}, "primary": true}],
      };
    // **END** Hextom TMS Integration - DO NOT MODIFY
        